import * as React from 'react'

const SvgSearchIcon = (props: React.SVGProps<SVGSVGElement>) => (
  <svg width={20} height={20} viewBox="0 0 20 20" fill="none" {...props}>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M18.75 17.869l-4.719-4.744a6.875 6.875 0 10-.906.906l4.744 4.719.881-.881zM3.125 8.75a5.625 5.625 0 1111.25 0 5.625 5.625 0 01-11.25 0z"
      fill="#163250"
    />
  </svg>
)

export default SvgSearchIcon
